export { ConnectionsPageTemplate as default } from './ConnectionsPageTemplate';
